import {
  Backdrop,
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  IconButton,
  Link,
  Modal,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import React from "react";
import ListResponsive from "../../../components/other/ListResponsive";
import {
  BCPArrowLeft,
  BCPArrowUpArrowDown,
  BCPDiceFive,
  BCPFilter,
  BCPLocationDot,
  BCPMap,
  BCPSquarePlus,
  BCPXmark
} from "../../../components/icons/bcp/BCPIcons";
import EventCard from "../../../components/layout/EventCard";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import OptionsMenu from "../../../components/layout/OptionsMenu";
import {
  clearFilterSx,
  getFilterSx,
  updateFilters
} from "../../../components/utilities/SortFilterFunctions";
import ListMap from "../../../components/other/ListMap";
import { cleanEventLocation } from "../../../components/utilities/UtilityFunctions";
import InfoContainer from "../../../components/layout/InfoContainer";
import { useTranslation } from "react-i18next";
const REQUIRES_ORGANIZER =
  getEnvironmentVariable("REQUIRES_ORGANIZER") === "true";

export default function EventsOrganizeDefault(props) {
  const {
    loading,
    hasMore,
    isSearching,
    deleteEvent,
    search,
    events,
    authContext,
    appMode,
    filters,
    setFilters,
    anchorEl,
    setAnchorEl,
    anchorEl2,
    setAnchorEl2,
    anchorEl3,
    setAnchorEl3,
    filteredEvents,
    setFilteredEvents,
    gameSystems,
    embed,
    title,
    organize = true,
    toggleMap,
    setToggleMap,
    activeEvents,
    setActiveEvents
  } = props;

  const theme = useTheme();
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.dashboards.organize"
  });

  return (
    <Box sx={{ width: "100%", mt: embed ? 2 : 0 }}>
      <Container
        sx={{
          pt: embed ? 0 : 2,
          pb: embed ? 0 : 2
        }}
        maxWidth={embed ? "xl" : "lg"}
      >
        <Grid container sx={{ gap: 2, p: embed ? 0 : 2 }}>
          {!embed && (
            <Grid item xs={12}>
              <Link
                href="/organize/dashboard"
                color="link.main"
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start"
                }}
              >
                <BCPArrowLeft
                  sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
                />{" "}
                {t("backToHostDashboard")}
              </Link>
            </Grid>
          )}

          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "flex" },
              justifyContent: "space-between"
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <Typography
                  variant="h2"
                  component="h3"
                  fontWeight="700"
                  gutterBottom
                >
                  {title || t("myManagedEvents")}
                </Typography>
              </Grid>

              <Hidden mdDown>
                {(REQUIRES_ORGANIZER &&
                  !authContext?.authState?.identity?.isAdmin &&
                  !authContext?.authState?.identity?.isOrganizer &&
                  !(!loading && !events?.length)) ||
                !organize ? (
                  <></>
                ) : (
                  <Grid item xs={12} md={3}>
                    <Button
                      variant="contained"
                      href="/organize/event"
                      target={`${appMode ? "_blank" : "_self"}`}
                      startIcon={<BCPSquarePlus />}
                      fullWidth
                    >
                      {t("newEvent")}
                    </Button>
                  </Grid>
                )}
              </Hidden>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            {!loading && !isSearching && !events?.length ? (
              <InfoContainer
                title={t("noEventsFoundTitle")}
                body={t("noEventsFoundDescription")}
                ActionButton={
                  <Button
                    variant="contained"
                    href={"/organize/event"}
                    startIcon={<BCPSquarePlus />}
                  >
                    {t("createEvent")}
                  </Button>
                }
                sx={{ mt: 1 }}
              />
            ) : (
              <ListResponsive
                originalList={
                  loading || isSearching
                    ? null
                    : filteredEvents !== null
                      ? filteredEvents
                      : events
                        ? events
                        : []
                }
                doSearch
                actionButton={
                  (REQUIRES_ORGANIZER &&
                    !authContext?.authState?.identity?.isAdmin &&
                    !authContext?.authState?.identity?.isOrganizer) ||
                  !organize
                    ? null
                    : {
                        props: {
                          variant: "contained",
                          color: "primary",
                          fullWidth: true,
                          href: "/organize/event",
                          target: `${appMode ? "_blank" : "_self"}`,
                          startIcon: <BCPSquarePlus />,
                          sx: {
                            display: { xs: "flex", md: "none" }
                          }
                        },
                        label: t("newEvent")
                      }
                }
                actionButtonBottom={[
                  {
                    label: t("sort"),
                    startIcon: <BCPArrowUpArrowDown />,
                    onClick: (e) => {
                      setAnchorEl(e.currentTarget);
                    },
                    disabled: loading || !events?.length,
                    sx: {
                      ...getFilterSx(
                        Boolean(
                          filters.length &&
                            filters.some((item) => item.includes("sort"))
                        ),
                        filters,
                        theme
                      )
                    }
                  },
                  {
                    label: t("filters"),
                    startIcon: <BCPFilter />,
                    onClick: (e) => {
                      setAnchorEl2(e.currentTarget);
                    },
                    disabled: loading || !events?.length,
                    sx: {
                      ...getFilterSx(
                        Boolean(
                          filters.length &&
                            filters.some((item) => item.includes("filter"))
                        ),
                        filters,
                        theme
                      )
                    }
                  },
                  getEnvironmentVariable("SINGLE_GAME_SYSTEM") !== "true" &&
                    getEnvironmentVariable("SINGLE_GAME_MANUFACTURER") !==
                      "true" && {
                      label: t("gameSystems"),
                      startIcon: <BCPDiceFive />,
                      disabled:
                        loading || !events?.length || !gameSystems?.length,
                      onClick: (e) => {
                        setAnchorEl3(e.currentTarget);
                      },
                      sx: {
                        ...getFilterSx(
                          Boolean(
                            filters.length &&
                              filters.some((item) =>
                                item.includes("gamesystem")
                              )
                          ),
                          filters,
                          theme
                        )
                      }
                    },
                  {
                    label: t("toggleMap"),
                    startIcon: <BCPMap />,
                    onClick: (e) => {
                      setToggleMap(!toggleMap);
                    },
                    disabled: loading || !events?.length,
                    sx: {
                      ...getFilterSx(!loading && toggleMap, filters, theme)
                    }
                  },
                  {
                    label: t("clearFilters"),
                    startIcon: <BCPXmark />,

                    disabled: loading || !events?.length,
                    sx: {
                      ...clearFilterSx(false, filters, theme)
                    },
                    onClick: () => {
                      updateFilters(null, null, null, setFilters);
                      setFilteredEvents(null);
                      setToggleMap(true);
                      setActiveEvents(null);
                      setAnchorEl(null);
                      setAnchorEl2(null);
                      setAnchorEl3(null);
                    }
                  }
                ]}
                searchProps={{
                  label: t("searchEvents"),
                  performSearch: (originalList, searchText) => {
                    if (!searchText || searchText === "") {
                      return originalList;
                    } else {
                      var filteredList = originalList.filter(function (el) {
                        if (
                          el?.eventLocation?.toLowerCase().includes(searchText)
                        )
                          return true;
                        if (el?.name?.toLowerCase().includes(searchText))
                          return true;
                        if (
                          el?.gameSystem?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        return false;
                      });
                      return filteredList;
                    }
                  }
                }}
                loadMore={search}
                hasMore={hasMore}
                scrollToTop
                rowProps={{
                  mapFunction: (row, index) => (
                    <Grid key={index} item xs={12} sm={6} md={4} sx={{ p: 1 }}>
                      <EventCard
                        event={row}
                        key={row?.id || index}
                        showStatus
                        organize={organize}
                        authContext={authContext}
                        deleteEvent={deleteEvent}
                        preventImageFetch
                      />
                    </Grid>
                  )
                }}
              >
                {toggleMap && !loading && (
                  <Box sx={{ mt: [0, embed && !organize ? 4 : 2] }}>
                    <ListMap
                      name="events-map"
                      originalList={
                        isSearching
                          ? null
                          : filteredEvents !== null
                            ? filteredEvents.filter(
                                (event) => !event?.isOnlineEvent
                              )
                            : events
                              ? events.filter((event) => !event?.isOnlineEvent)
                              : []
                      }
                      zoom={9}
                      sx={{ mb: 1, mt: [0, -2] }}
                      mapSx={{ height: "30vh" }}
                      defaultCenter={
                        filteredEvents?.length
                          ? {
                              lat: filteredEvents?.[0]?.coordinate?.[1],
                              lng: filteredEvents?.[0]?.coordinate?.[0]
                            }
                          : events?.length
                            ? {
                                lat: events?.[0]?.coordinate?.[1],
                                lng: events?.[0]?.coordinate?.[0]
                              }
                            : null
                      }
                      onClick={(lat, lng) => {
                        const eventArr = [];
                        events.forEach((event) => {
                          if (
                            event?.coordinate?.[0] === lng &&
                            event?.coordinate?.[1] === lat
                          ) {
                            eventArr.push(event);
                          }
                        });

                        setActiveEvents(eventArr);
                      }}
                      filterFunction={(event) =>
                        !event?.isOnlineEvent &&
                        (event?.coordinate?.length ||
                          event?.coordinate_point?.coordinates?.length) &&
                        (event?.coordinate[0] ||
                          event?.coordinate_point?.coordinates[0]) &&
                        (event?.coordinate[1] ||
                          event?.coordinate_point?.coordinates[1])
                      }
                    />
                  </Box>
                )}
              </ListResponsive>
            )}
          </Grid>

          {/* Sorting */}
          <OptionsMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            items={[
              {
                name: "sort-date-asc",
                label: t("startDateAscending"),
                selected: filters.includes("sort-date-asc"),
                onClick: () =>
                  updateFilters("sort-date-asc", false, filters, setFilters)
              },
              {
                name: "sort-date-desc",
                label: t("startDateDescending"),
                selected: filters.includes("sort-date-desc"),
                onClick: () =>
                  updateFilters("sort-date-desc", false, filters, setFilters)
              },
              {
                name: "sort-name-asc",
                label: t("nameAscending"),
                selected: filters.includes("sort-name-asc"),
                onClick: () =>
                  updateFilters("sort-name-asc", false, filters, setFilters)
              },
              {
                name: "sort-name-desc",
                label: t("nameDescending"),
                selected: filters.includes("sort-name-desc"),
                onClick: () =>
                  updateFilters("sort-name-desc", false, filters, setFilters)
              },
              {
                name: "sort-rounds-asc",
                label: t("roundsAscending"),
                selected: filters.includes("sort-rounds-asc"),
                onClick: () =>
                  updateFilters("sort-rounds-asc", false, filters, setFilters)
              },
              {
                name: "sort-rounds-desc",
                label: t("roundsDescending"),
                selected: filters.includes("sort-rounds-desc"),
                onClick: () =>
                  updateFilters("sort-rounds-desc", false, filters, setFilters)
              }
            ]}
            name="events-sort-menu"
          />

          {/* Filters */}
          <OptionsMenu
            anchorEl={anchorEl2}
            setAnchorEl={setAnchorEl2}
            items={[
              {
                name: "filter-online",
                label: t("onlineEvent"),
                selected: filters.includes("filter-online"),
                onClick: () =>
                  updateFilters(
                    "filter-online",
                    "filter-exclude-online",
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-exclude-online",
                label: t("excludeOnline"),
                selected: filters.includes("filter-exclude-online"),
                onClick: () =>
                  updateFilters(
                    "filter-exclude-online",
                    "filter-online",
                    filters,
                    setFilters
                  )
              },
              { divider: true },

              embed
                ? null
                : {
                    name: "filter-org",
                    label: t("gameStoreEvents"),
                    selected: filters.includes("filter-org"),
                    onClick: () =>
                      updateFilters(
                        "filter-org",
                        "filter-exclude-org",
                        filters,
                        setFilters
                      )
                  },
              embed
                ? null
                : {
                    name: "filter-exclude-org",
                    label: t("excludeGameStoreEvents"),
                    selected: filters.includes("filter-exclude-org"),
                    onClick: () =>
                      updateFilters(
                        "filter-exclude-org",
                        "filter-org",
                        filters,
                        setFilters
                      )
                  },
              embed ? null : { divider: true },

              {
                name: "filter-singles",
                label: t("singlesEvents"),
                selected: filters.includes("filter-singles"),
                onClick: () =>
                  updateFilters(
                    "filter-singles",
                    ["filter-doubles", "filter-teams", "filter-board"],
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-doubles",
                label: t("doublesEvents"),
                selected: filters.includes("filter-doubles"),
                onClick: () =>
                  updateFilters(
                    "filter-doubles",
                    ["filter-singles", "filter-teams", "filter-board"],
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-teams",
                label: t("teamsEvents"),
                selected: filters.includes("filter-teams"),
                onClick: () =>
                  updateFilters(
                    "filter-teams",
                    ["filter-singles", "filter-doubles", "filter-board"],
                    filters,
                    setFilters
                  )
              }
            ]}
            name="events-filter-menu"
          />

          {/* Game Systems */}
          {gameSystems?.length && (
            <OptionsMenu
              anchorEl={anchorEl3}
              setAnchorEl={setAnchorEl3}
              items={gameSystems.map((gameSystem) => ({
                name: `gamesystem-${gameSystem?.id}`,
                label: gameSystem.name,
                selected: filters.includes(`gamesystem-${gameSystem?.id}`),
                onClick: () =>
                  updateFilters(
                    `gamesystem-${gameSystem?.id}`,
                    false,
                    filters,
                    setFilters
                  )
              }))}
              name="gamesystem-menu"
            />
          )}

          {activeEvents?.length && (
            <ActiveEventsModal
              activeEvents={activeEvents}
              setActiveEvents={setActiveEvents}
              organize={organize}
            />
          )}
        </Grid>
      </Container>
    </Box>
  );
}

export function ActiveEventsModal(props) {
  const { activeEvents, setActiveEvents, organize } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "pages.dashboards.organize"
  });

  return (
    <Modal
      disableAutoFocus
      open={Boolean(activeEvents)}
      onClose={() => {
        setActiveEvents(null);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "modal.background",
          color: "modal.text",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          overflowY: "scroll"
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setActiveEvents(null);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h2" component="h4">
              {t("eventsAtThisLocation")}
            </Typography>
          </Grid>

          {activeEvents.map((event, index) => (
            <Grid item xs={12} key={index}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "700",
                  textTransform: "none",
                  ml: 4
                }}
                gutterBottom
              >
                <Link
                  sx={{ textDecoration: "none", color: "text.primary" }}
                  href={`${organize ? "/organize" : ""}/event/${event.id}`}
                >
                  {`${event.name}`}
                </Link>
              </Typography>
              <Typography sx={{ mb: 1 }}>
                <Link
                  underline="none"
                  href={`https://google.com/maps/place/${
                    event.location?.streetNum || ""
                  } ${event.location?.streetName || ""} ${
                    event.location?.city
                  } ${event.location?.zip || ""} ${
                    event.location?.state || ""
                  } ${event.location?.country || ""}`.trim()}
                  target="_blank"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box
                    sx={{
                      minWidth: "35px",
                      verticalAlign: "bottom",
                      display: "inline-flex"
                    }}
                  >
                    <Tooltip title="Location">
                      <BCPLocationDot
                        style={{
                          color: "text.secondary",
                          "vertical-align": "bottom"
                        }}
                      />
                    </Tooltip>
                  </Box>

                  <Box>
                    {event?.locationName && (
                      <Typography>{event?.locationName}</Typography>
                    )}
                    {cleanEventLocation(event) && (
                      <Typography>
                        {cleanEventLocation(event)
                          ? cleanEventLocation(event)
                          : ""}
                      </Typography>
                    )}
                  </Box>
                </Link>
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Box></Box>
      </Box>
    </Modal>
  );
}
